import { keepPreviousData } from '@tanstack/react-query';

import { AppID, Environment, TimePrecision } from '@playq/octopus-common';
import { MetaResponse } from '@playq/services-beetle';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { iteratorMaxLimit } from '/constants';
import { toMs } from '/helpers/toMs';

import { SupportContentType } from './types/supportContentType';
import { methods } from './serviceHandlerRequest';

export const metaKeys: unknown[] = ['query', 'service', 'audience', 'meta'];

const emptyArray: [] = [];

export const useQueryMeta = (
  {
    type,
    appId,
    env = Environment.Live,
    entityExist,
    keys = iteratorMaxLimit,
    valuesPerKey = iteratorMaxLimit,
  }: {
    type: SupportContentType;
    appId?: AppID;
    env: Environment;
    entityExist?: boolean;
    keys?: typeof iteratorMaxLimit;
    valuesPerKey?: typeof iteratorMaxLimit;
  },
  options?: IUseQueryOptionsExtended<MetaResponse | undefined, GenericFailure | Error>
) => {
  const request = methods(type);

  const tags = metaKeys.concat(type, env, keys, valuesPerKey, appId?.serialize());

  const res = useEitherQuery(tags, () => request.queryMeta(appId as AppID, keys, valuesPerKey, env), {
    placeholderData: keepPreviousData,
    staleTime: toMs(TimePrecision.Minute, 5),

    enabled: entityExist,
    ...options,
  });

  return { ...res, keys: res.data?.keys || emptyArray };
};
